import { Core } from '@springtree/eva-services-core';
import productDetailState from './product-detail-state.js';
import buildServiceState from '../../builders/build-service-state.js';
const productDetailConfigurableState = buildServiceState({
    allowEmptyRequest: false,
    key: 'productDetailConfigurable',
    service: Core.GetConfigurableProductDetail,
    beforeRequest: ({ req, get }) => {
        const currentProduct = get(productDetailState.response);
        const productId = currentProduct && currentProduct.Result?.product_id;
        // Fetch configurable if this is a configurable product
        // 16384 is configurable product
        //
        const productTypes = currentProduct?.Result?.product_types || [];
        const isConfigurable = productTypes.indexOf(16384) !== -1;
        if (!productId || !isConfigurable) {
            return;
        }
        const newRequest = {
            ...req,
            ID: productId,
        };
        return newRequest;
    },
});
export default productDetailConfigurableState;
//# sourceMappingURL=product-detail-configurable-state.js.map